export const ROUTES = {
  DASHBOARD: "/",
  MY_TASKS: "/my-tasks",
  MY_TIMESHEET: "/my-timesheet",
  MY_EXPENSES: "/my-expenses",
  MY_REFERRALS: "/my-referrals",
  THUNDER: "/thunder",
  RESOURCE_MANAGEMENT: "/resource-management",
  CORE_PULL: "/core-pull",
  CLIENT_MANAGEMENT: "/client-management",
  OPPORTUNITY_PIPELINE: "/opportunity-pipeline",
  EXECUTIVE_REVENUE_DASHBOARD: "/executive-revenue-dashboard",
  FINANCE_OPERATIONS: "/finance-operations",
  PNL: "/pnl",
  DEMAND_CONFIRMATION: "/demand-confirmation",
  EMPLOYEES: "/employees",
  EMPLOYEE_CONVERSION: "/employee-conversion",
  HIRING_PIPELINE: "/hiring-pipeline",
  LINKEDIN_PIPELINE: "/linkedin-pipeline",
  PIPELINE: "/pipeline",
  SUBMISSIONS: "/submissions",
  PROJECTS: "/projects",
  HTD_INTAKE: "/htd-intake",
  HM_CANDIDATE_REVIEW: "/hm-candidate-review",
  UTILIZATION_DASHBOARD: "/utilization-dashboard",
  TIMESHEETS: "/timesheets",
  FORECAST: "/forecast",
  FORECAST_VS_ACTUAL: "/forecast-vs-actual",
  INVOICES: "/invoices",
  REVENUE: "/revenue",
  TENANT_LOCALE: "/settings/locale",
  API_KEYS_SETTINGS: "/api-keys",
  SLM_DASHBOARD: "/admin/slm-dashboard",
  SLM_TRAINING: "/admin/slm-training",
  SLM_LEARNING_TRANSCRIPT: "/admin/slm-learning-transcript",
  CANDIDATES: "/candidates",
  CANDIDATE_CREATE: "/candidates/create",
  CANDIDATE_DETAILS: "/candidates/details",
  JOBS: "/jobs",
  JOB_CREATE: "/jobs/create",
  JOB_DETAILS: "/jobs/details",
  JOB_WORKSPACE: "/jobs/workspace",
  USERS_ACCESS_CONTROL: "/admin/users-access-control",
  USERS_ACCESS_CONTROL_USERS: "/admin/users-access-control/users",
  USERS_ACCESS_CONTROL_BUSINESS_UNITS: "/admin/users-access-control/business-units",
  USERS_ACCESS_CONTROL_DELIVERY_CENTERS: "/admin/users-access-control/delivery-centers",
  USERS_ACCESS_CONTROL_ORG_HIERARCHY: "/admin/users-access-control/organizational-hierarchy",
  USERS_ACCESS_CONTROL_ROLE_TEMPLATES: "/admin/users-access-control/role-templates",
  // Administration module routes
  ADMIN_USERS: "/admin/users-access-control/users",
  ADMIN_BUSINESS_UNITS: "/admin/users-access-control/business-units",
  ADMIN_DELIVERY_CENTERS: "/admin/users-access-control/delivery-centers",
  ADMIN_ORG_HIERARCHY: "/admin/users-access-control/organizational-hierarchy",
  ADMIN_ROLE_TEMPLATES: "/admin/users-access-control/role-templates",
  CERTIFICATIONS: "/admin/certifications",
  OFFERS_LISTING: "/offers-listing",
  INTERVENTION_QUEUE: "/recruiter/intervention-queue",
  REHIRE_APPROVALS: "/recruiter/rehire-approvals",
  RISK_DASHBOARD: "/recruiter/risk-dashboard",
  THUNDER_ANALYTICS: "/recruiter/thunder-analytics",
  BULK_LAUNCH: "/recruiter/bulk-launch",
  TENANT_AI_CONFIG: "/admin/ai-config",
  TICKET_ROUTING_ADMIN: "/admin/ticket-routing",
  BUDDY_PROGRAM: "/buddy-program",
  EXECUTIVE_SIGNAL: "/executive-signal",
  CEO_FY_PROGRESS: "/ceo-fy-progress",
  CFO_DASHBOARD: "/cfo-dashboard",
  ERROR_LOG: "/admin/error-log",
  ADMIN_WEEKLY_RECAP: "/admin/weekly-recap",
  PARTNER_DASHBOARD: "/partner-dashboard",
  BI_EXPLORER: "/bi-explorer",
  BU_HEAD_DASHBOARD: "/bu-head-dashboard",
};